import LegalLayout from './LegalLayout';

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy">
      <h1 className="text-3xl font-bold mb-4 text-orange-300">Privacy Policy</h1>
      <p className="mb-4"><b>Last updated: May 2025</b></p>
      <p className="mb-4">
        MockWit.ai (“we”, “us”, or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Information We Collect</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Contact information (such as email, if you contact us)</li>
        <li>Usage data (analytics, cookies, log files)</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4">
        <li>To provide, operate, and improve our services</li>
        <li>To communicate with you regarding inquiries or support</li>
        <li>For analytics and security purposes</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">How We Share Information</h2>
      <p className="mb-4">
        We do not sell or rent your personal information. We may share data with trusted service providers (for hosting, analytics, or email communication) under strict confidentiality agreements.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Your Choices</h2>
      <ul className="list-disc list-inside mb-4">
        <li>You may request access or deletion of your information by contacting us at <a className="text-orange-300 underline" href="mailto:support@mockwit.ai">support@mockwit.ai</a>.</li>
        <li>You may opt out of marketing communications at any time.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Security</h2>
      <p className="mb-4">
        We implement industry-standard security measures to protect your data. However, no method of transmission over the Internet is completely secure.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Children’s Privacy</h2>
      <p className="mb-4">
        Our services are not intended for children under 16. We do not knowingly collect data from children under 16.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Changes to This Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. Updates will be posted on this page.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Contact Us</h2>
      <p>
        For questions or requests, please email <a className="text-orange-300 underline" href="mailto:support@mockwit.ai">support@mockwit.ai</a>.
      </p>
    </LegalLayout>
  );
}
